import { HollandCode } from "./HollandCode";

export class Occupation {
    public title: string;
    public hollandCode: HollandCode;

    constructor(title: string, code: HollandCode) {
        this.title = title;
        this.hollandCode = code;
    }

    public static OCCUPATIONS: Occupation[] = [
        new Occupation("JobMatching.Phaser.jobs.R.1", HollandCode.R),
        new Occupation("JobMatching.Phaser.jobs.R.2", HollandCode.R),
        new Occupation("JobMatching.Phaser.jobs.I.1", HollandCode.I),
        new Occupation("JobMatching.Phaser.jobs.I.2", HollandCode.I),
        new Occupation("JobMatching.Phaser.jobs.A.1", HollandCode.A),
        new Occupation("JobMatching.Phaser.jobs.S.1", HollandCode.S),
        new Occupation("JobMatching.Phaser.jobs.S.2", HollandCode.S),
        new Occupation("JobMatching.Phaser.jobs.E.1", HollandCode.E),
        new Occupation("JobMatching.Phaser.jobs.E.2", HollandCode.E),
        new Occupation("JobMatching.Phaser.jobs.C.1", HollandCode.C),
    ];
}



// WEBPACK FOOTER //
// ./src/games/JobMatchingGame/objects/Occupation.ts